<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="isShow"
      width="30%"
      :before-close="handleClose"
      center
      @open="openFn"
    >
      <div class="content">
        <PassWordInput
          @inputFinish="inputFinish"
          class="password-box"
          ref="pwd"
        ></PassWordInput>
        <!-- <PassWordInput
          @inputFinish="inputFinish2"
          class="password-box"
          ref="pwd2"
        ></PassWordInput> -->
        <!-- <el-button @click="submit">确定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      password2: "",
    };
  },
  props: {
    isShow: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "请输入密码",
    },
  },
  components: {
    PassWordInput: () => import("./PassWordInput.vue"),
  },
  methods: {
    openFn() {
      if (this.$refs.pwd) {
        this.$refs.pwd.msg = "";
      }
    },
    handleClose() {
      this.$emit("close");
    },
    inputFinish(e) {
      this.password = e;
      if (this.password.length == 6) {
        this.$emit("getPassword", this.password);
      }

      // this.$emit("getPassword", this.password,this.password2);
    },
    // inputFinish2(e) {
    //   this.password2 = e;
    //   this.$emit("getPwd", this.password,this.password2);
    // },
    // submit () {
    //   this.isShow = false
    //   this.$router.go(-1)
    //   console.log(this.password)
    // }
  },
};
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
  .password-box {
    min-height: 200px;
  }
}
</style>
